define(["exports", "hyperhtml"], function (_exports, _hyperhtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject31() {
    const data = _taggedTemplateLiteral(["\n                  with <code>", "</code> at the start of your\n                  email's subject\n                "]);

    _templateObject31 = function _templateObject31() {
      return data;
    };

    return data;
  }

  function _templateObject30() {
    const data = _taggedTemplateLiteral(["\n            ", "\n            Please send them to\n            <a href=\"", "\"\n              >", "@w3.org</a\n            >\n            (<a\n              href=\"", "\"\n              >archives</a\n            >)", ".\n          "]);

    _templateObject30 = function _templateObject30() {
      return data;
    };

    return data;
  }

  function _templateObject29() {
    const data = _taggedTemplateLiteral(["\n            <a href=\"", "\">GitHub Issues</a> are preferred for\n            discussion of this specification.\n          "]);

    _templateObject29 = function _templateObject29() {
      return data;
    };

    return data;
  }

  function _templateObject28() {
    const data = _taggedTemplateLiteral(["\n    <p>\n      ", "\n      ", "\n    </p>\n  "]);

    _templateObject28 = function _templateObject28() {
      return data;
    };

    return data;
  }

  function _templateObject27() {
    const data = _taggedTemplateLiteral(["\n    <p>\n      This document was published by ", " as ", "\n      ", ".\n      ", "\n    </p>\n  "]);

    _templateObject27 = function _templateObject27() {
      return data;
    };

    return data;
  }

  function _templateObject26() {
    const data = _taggedTemplateLiteral(["\n            with <code>", "</code> at the start of your email's\n            subject\n          "]);

    _templateObject26 = function _templateObject26() {
      return data;
    };

    return data;
  }

  function _templateObject25() {
    const data = _taggedTemplateLiteral(["\n    <p>\n      If you wish to make comments regarding this document, please send them to\n      <a href=\"", "\"\n        >", "@w3.org</a\n      >\n      (<a href=\"", "\">subscribe</a>,\n      <a href=\"", "\"\n        >archives</a\n      >)", ".\n    </p>\n    <p>\n      Please consult the complete\n      <a href=\"https://www.w3.org/TeamSubmission/\">list of Team Submissions</a>.\n    </p>\n  "]);

    _templateObject25 = function _templateObject25() {
      return data;
    };

    return data;
  }

  function _templateObject24() {
    const data = _taggedTemplateLiteral(["\n    <p>\n      By publishing this document, W3C acknowledges that the\n      <a href=\"", "\">Submitting Members</a> have made a formal\n      Submission request to W3C for discussion. Publication of this document by\n      W3C indicates no endorsement of its content by W3C, nor that W3C has, is,\n      or will be allocating any resources to the issues addressed by it. This\n      document is not the product of a chartered W3C group, but is published as\n      potential input to the\n      <a href=\"https://www.w3.org/Consortium/Process\">W3C Process</a>. A\n      <a href=\"", "\">W3C Team Comment</a> has been published in\n      conjunction with this Member Submission. Publication of acknowledged\n      Member Submissions at the W3C site is one of the benefits of\n      <a href=\"https://www.w3.org/Consortium/Prospectus/Joining\">\n        W3C Membership</a\n      >. Please consult the requirements associated with Member Submissions of\n      <a href=\"https://www.w3.org/Consortium/Patent-Policy/#sec-submissions\"\n        >section 3.3 of the W3C Patent Policy</a\n      >. Please consult the complete\n      <a href=\"https://www.w3.org/Submission\"\n        >list of acknowledged W3C Member Submissions</a\n      >.\n    </p>\n  "]);

    _templateObject24 = function _templateObject24() {
      return data;
    };

    return data;
  }

  function _templateObject23() {
    const data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "]);

    _templateObject23 = function _templateObject23() {
      return data;
    };

    return data;
  }

  function _templateObject22() {
    const data = _taggedTemplateLiteral(["\n            The disclosure obligations of the Participants of this group are\n            described in the\n            <a href=\"", "\">charter</a>.\n          "]);

    _templateObject22 = function _templateObject22() {
      return data;
    };

    return data;
  }

  function _templateObject21() {
	  const data = _taggedTemplateLiteral(["\n                  W3C maintains a\n                  <a href=\"", "\" rel=\"disclosure\"\n                    >public list of any patent disclosures</a\n                  >\n                "]);

    _templateObject21 = function _templateObject21() {
      return data;
    };

    return data;
  }

  function _templateObject20() {
    const data = _taggedTemplateLiteral(["\n                  W3C maintains ", "\n                "]);

    _templateObject20 = function _templateObject20() {
      return data;
    };

    return data;
  }

  function _templateObject19() {
    const data = _taggedTemplateLiteral(["\n            ", "\n            made in connection with the deliverables of\n            ", "\n            instructions for disclosing a patent. An individual who has actual\n            knowledge of a patent which the individual believes contains\n            <a href=\"https://www.w3.org/Consortium/Patent-Policy/#def-essential\"\n              >Essential Claim(s)</a\n            >\n            must disclose the information in accordance with\n            <a\n              href=\"https://www.w3.org/Consortium/Patent-Policy/#sec-Disclosure\"\n              >section 6 of the W3C Patent Policy</a\n            >.\n          "]);

    _templateObject19 = function _templateObject19() {
      return data;
    };

    return data;
  }

  function _templateObject18() {
    const data = _taggedTemplateLiteral(["\n    <p data-deliverer=\"", "\">\n      ", " ", "\n      ", "\n      ", "\n    </p>\n  "]);

    _templateObject18 = function _templateObject18() {
      return data;
    };

    return data;
  }

  function _templateObject17() {
    const data = _taggedTemplateLiteral(["\n        This document was produced by ", "\n        operating under the\n        <a href=\"https://www.w3.org/Consortium/Patent-Policy/\"\n          >W3C Patent Policy</a\n        >.\n      "]);

    _templateObject17 = function _templateObject17() {
      return data;
    };

    return data;
  }

  function _templateObject16() {
    const data = _taggedTemplateLiteral(["\n    <p>\n      This document has been reviewed by W3C Members, by software developers,\n      and by other W3C groups and interested parties, and is endorsed by the\n      Director as a W3C Recommendation. It is a stable document and may be used\n      as reference material or cited from another document. W3C's role in making\n      the Recommendation is to draw attention to the specification and to\n      promote its widespread deployment. This enhances the functionality and\n      interoperability of the Web.\n    </p>\n  "]);

    _templateObject16 = function _templateObject16() {
      return data;
    };

    return data;
  }

  function _templateObject15() {
	  const data = _taggedTemplateLiteral(["\n    <p>\n      Publication as ", " ", " does not imply endorsement by the\n      W3C Membership. This is a draft document and may be updated, replaced or\n      obsoleted by other documents at any time. It is inappropriate to cite this\n      document as other than work in progress.\n    </p>\n  "]);

    _templateObject15 = function _templateObject15() {
      return data;
    };

    return data;
  }

/* EEA specStatus */
  function _templateObject15eea() {
    const data = _taggedTemplateLiteral(["", "", ""]);

    _templateObject15eea = function _templateObject15eea() {
      return data;
    };

    return data;
  }

  function _templateObject14() {
    const data = _taggedTemplateLiteral(["\n    <p>\n      Please see the Working Group's\n      <a href=\"", "\">implementation report</a>.\n    </p>\n  "]);

    _templateObject14 = function _templateObject14() {
      return data;
    };

    return data;
  }

  function _templateObject13() {
    const data = _taggedTemplateLiteral(["\n    <p>\n      This document is merely a W3C-internal\n      ", " document. It has no official standing\n      of any kind and does not represent consensus of the W3C Membership.\n    </p>\n    ", "\n  "]);

    _templateObject13 = function _templateObject13() {
      return data;
    };

    return data;
  }

  function _templateObject12() {
    const data = _taggedTemplateLiteral(["\n    <p>\n      This document is draft of a potential specification. It has no official\n      standing of any kind and does not represent the support or consensus of\n      any standards organization.\n    </p>\n    ", "\n  "]);

    _templateObject12 = function _templateObject12() {
      return data;
    };

    return data;
  }

  function _templateObject11() {
    const data = _taggedTemplateLiteral(["\n              Instead, see\n              <a href=\"", "\">", "</a> for the Editor's draft.\n            "]);

    _templateObject11 = function _templateObject11() {
      return data;
    };

    return data;
  }

  function _templateObject10() {
    const data = _taggedTemplateLiteral(["\n              of pull request\n              <a href=\"", "\">#", "</a>\n            "]);

    _templateObject10 = function _templateObject10() {
      return data;
    };

    return data;
  }

  function _templateObject9() {
    const data = _taggedTemplateLiteral(["\n    <details class=\"annoying-warning\" open=\"\">\n      <summary\n        >This is a\n        preview", "</summary\n      >\n      <p>\n        Do not attempt to implement this version of the specification. Do not\n        reference this version as authoritative in any way.\n        ", "\n      </p>\n    </details>\n  "]);

    _templateObject9 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8() {
    const data = _taggedTemplateLiteral(["\n                      <p>", "</p>\n                    "]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["\n                                    The W3C Membership and other interested\n                                    parties are invited to review the document\n                                    and send comments to\n                                    <a\n                                      rel=\"discussion\"\n                                      href=\"", "\"\n                                      >", "@w3.org</a\n                                    >\n                                    (<a\n                                      href=\"", "\"\n                                      >subscribe</a\n                                    >,\n                                    <a\n                                      href=\"", "\"\n                                      >archives</a\n                                    >) through ", ". Advisory\n                                    Committee Representatives should consult\n                                    their\n                                    <a\n                                      href=\"https://www.w3.org/2002/09/wbs/myQuestionnaires\"\n                                      >WBS questionnaires</a\n                                    >. Note that substantive technical comments\n                                    were expected during the Candidate\n                                    Recommendation review period that ended\n                                    ", ".\n                                  "]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["\n                                    W3C Advisory Committee Members are invited\n                                    to send formal review comments on this\n                                    Proposed Edited Recommendation to the W3C\n                                    Team until ", ". Members of\n                                    the Advisory Committee will find the\n                                    appropriate review form for this document by\n                                    consulting their list of current\n                                    <a\n                                      href=\"https://www.w3.org/2002/09/wbs/myQuestionnaires\"\n                                      >WBS questionnaires</a\n                                    >.\n                                  "]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["\n                            <p>\n                              ", "\n                              ", "\n                              ", "\n                            </p>\n                          "]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["\n                      ", " ", "\n                      ", "\n                    "]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["\n                ", "\n                ", "\n                ", "\n                ", "\n                ", "\n                ", " ", "\n                <p>\n                  This document is governed by the\n                  <a\n                    id=\"w3c_process_revision\"\n                    href=\"https://www.w3.org/2019/Process-20190301/\"\n                    >1 March 2019 W3C Process Document</a\n                  >.\n                </p>\n                ", "\n              "]); 

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

/* EEA specStatus */
  function _templateObject3eea() {
    const data = _taggedTemplateLiteral(["", "", "", "", "", "", "", "", ""]);

    _templateObject3eea = function _templateObject3eea() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n          <p><em>", "</em></p>\n          ", "\n        "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n    <h2>", "</h2>\n    ", "\n    ", "\n    ", "\n  "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  var _default = (conf, opts) => {
/* EEA specStatus */
/* Update sotd statement and remove document governance paragraph */
    if (conf.specStatus === "EEA") {
      conf.l10n.status_at_publication = "This section describes the status of this document at the time of its publication. Newer documents may supersede this document.";
      return (0, _hyperhtml.default)(_templateObject(), conf.l10n.sotd, conf.isPreview ? renderPreview(conf) : "", conf.isUnofficial ? renderIsUnofficial(opts) : conf.isTagFinding ? opts.additionalContent : conf.isNoTrack ? renderIsNoTrack(conf, opts) : (0, _hyperhtml.default)(_templateObject2(), [conf.l10n.status_at_publication], conf.isSubmission ? noteForSubmission(conf, opts) : (0, _hyperhtml.default)(_templateObject3eea(), !conf.sotdAfterWGinfo ? opts.additionalContent : "", !conf.overrideStatus ? (0, _hyperhtml.default)(_templateObject4(), linkToWorkingGroup(conf), linkToCommunity(conf, opts), conf.isCR || conf.isPER || conf.isPR ? (0, _hyperhtml.default)(_templateObject5(), conf.isCR ? "\n                  W3C publishes a Candidate Recommendation to indicate that the document is believed to be\n                  stable and to encourage implementation by the developer community. This Candidate\n                  Recommendation is expected to advance to Proposed Recommendation no earlier than\n                  ".concat(conf.humanCREnd, ".\n                ") : "", conf.isPER ? (0, _hyperhtml.default)(_templateObject6(), conf.humanPEREnd) : "", conf.isPR ? (0, _hyperhtml.default)(_templateObject7(), opts.mailToWGPublicList, conf.wgPublicList, opts.mailToWGPublicListSubscription, "https://lists.w3.org/Archives/Public/".concat(conf.wgPublicList, "/"), conf.humanPREnd, conf.humanCREnd) : "") : "") : "", conf.implementationReportURI ? renderImplementationReportURI(conf) : "", conf.sotdAfterWGinfo ? opts.additionalContent : "", conf.notRec ? renderNotRec(conf) : "", conf.isRec ? renderIsRec() : "", renderDeliverer(conf), conf.addPatentNote ? (0, _hyperhtml.default)(_templateObject8(), [conf.addPatentNote]) : "")), opts.additionalSections);
    } else {
      return (0, _hyperhtml.default)(_templateObject(), conf.l10n.sotd, conf.isPreview ? renderPreview(conf) : "", conf.isUnofficial ? renderIsUnofficial(opts) : conf.isTagFinding ? opts.additionalContent : conf.isNoTrack ? renderIsNoTrack(conf, opts) : (0, _hyperhtml.default)(_templateObject2(), [conf.l10n.status_at_publication], conf.isSubmission ? noteForSubmission(conf, opts) : (0, _hyperhtml.default)(_templateObject3(), !conf.sotdAfterWGinfo ? opts.additionalContent : "", !conf.overrideStatus ? (0, _hyperhtml.default)(_templateObject4(), linkToWorkingGroup(conf), linkToCommunity(conf, opts), conf.isCR || conf.isPER || conf.isPR ? (0, _hyperhtml.default)(_templateObject5(), conf.isCR ? "\n                  W3C publishes a Candidate Recommendation to indicate that the document is believed to be\n                  stable and to encourage implementation by the developer community. This Candidate\n                  Recommendation is expected to advance to Proposed Recommendation no earlier than\n                  ".concat(conf.humanCREnd, ".\n                ") : "", conf.isPER ? (0, _hyperhtml.default)(_templateObject6(), conf.humanPEREnd) : "", conf.isPR ? (0, _hyperhtml.default)(_templateObject7(), opts.mailToWGPublicList, conf.wgPublicList, opts.mailToWGPublicListSubscription, "https://lists.w3.org/Archives/Public/".concat(conf.wgPublicList, "/"), conf.humanPREnd, conf.humanCREnd) : "") : "") : "", conf.implementationReportURI ? renderImplementationReportURI(conf) : "", conf.sotdAfterWGinfo ? opts.additionalContent : "", conf.notRec ? renderNotRec(conf) : "", conf.isRec ? renderIsRec() : "", renderDeliverer(conf), conf.addPatentNote ? (0, _hyperhtml.default)(_templateObject8(), [conf.addPatentNote]) : "")), opts.additionalSections);
    }
  };

  _exports.default = _default;

  function renderPreview(conf) {
    const {
      prUrl,
      prNumber,
      edDraftURI
    } = conf;
    return (0, _hyperhtml.default)(_templateObject9(), prUrl && prNumber ? (0, _hyperhtml.default)(_templateObject10(), prUrl, prNumber) : "", edDraftURI ? (0, _hyperhtml.default)(_templateObject11(), edDraftURI, edDraftURI) : "");
  }

  function renderIsUnofficial(opts) {
    const {
      additionalContent
    } = opts;
    return (0, _hyperhtml.default)(_templateObject12(), additionalContent);
  }

  function renderIsNoTrack(conf, opts) {
    const {
      isMO
    } = conf;
    const {
      additionalContent
    } = opts;
    return (0, _hyperhtml.default)(_templateObject13(), isMO ? "member-confidential" : "", additionalContent);
  }

  function renderImplementationReportURI(conf) {
    const {
      implementationReportURI
    } = conf;
    return (0, _hyperhtml.default)(_templateObject14(), implementationReportURI);
  }

  function renderNotRec(conf) {
    const {
      anOrA,
      textStatus
    } = conf;
/* EEA specStatus */
/* Remove publication endorsement paragraph */
    if (conf.specStatus === "EEA") {
      return (0, _hyperhtml.default)(_templateObject15eea(), "", "");
    } else {
      return (0, _hyperhtml.default)(_templateObject15(), anOrA, textStatus);
    }
  }

  function renderIsRec() {
    (0, _hyperhtml.default)(_templateObject16());
  }

  function renderDeliverer(conf) {
    const {
      isNote,
      wgId,
      isIGNote,
      multipleWGs,
      recNotExpected,
      wgPatentHTML,
      wgPatentURI,
      charterDisclosureURI
    } = conf;
    const producers = !isIGNote ? (0, _hyperhtml.default)(_templateObject17(), multipleWGs ? "groups" : "a group") : ""; 
    const wontBeRec = recNotExpected ? "The group does not expect this document to become a W3C Recommendation." : "";
/* EEA specStatus */
    if (conf.specStatus !== "EEA") {
      return (0, _hyperhtml.default)(_templateObject18(), isNote ? wgId : null, producers, wontBeRec, !isNote && !isIGNote ? (0, _hyperhtml.default)(_templateObject19(), multipleWGs ? (0, _hyperhtml.default)(_templateObject20(), [wgPatentHTML]) : (0, _hyperhtml.default)(_templateObject21(), [wgPatentURI]), multipleWGs ? "each group; these pages also include" : "the group; that page also includes") : "", isIGNote ? (0, _hyperhtml.default)(_templateObject22(), charterDisclosureURI) : "");
    }
  }

  function noteForSubmission(conf, opts) {
    return (0, _hyperhtml.default)(_templateObject23(), opts.additionalContent, conf.isMemberSubmission ? noteForMemberSubmission(conf) : conf.isTeamSubmission ? noteForTeamSubmission(conf, opts) : "");
  }

  function noteForMemberSubmission(conf) {
    const teamComment = "https://www.w3.org/Submission/".concat(conf.publishDate.getUTCFullYear(), "/").concat(conf.submissionCommentNumber, "/Comment/");
    return (0, _hyperhtml.default)(_templateObject24(), conf.thisVersion, teamComment);
  }

  function noteForTeamSubmission(conf, opts) {
    return (0, _hyperhtml.default)(_templateObject25(), opts.mailToWGPublicListWithSubject, conf.wgPublicList, opts.mailToWGPublicListSubscription, "https://lists.w3.org/Archives/Public/".concat(conf.wgPublicList, "/"), conf.subjectPrefix ? (0, _hyperhtml.default)(_templateObject26(), conf.subjectPrefix) : "");
  }

  function linkToWorkingGroup(conf) {
    if (!conf.wg) {
      return;
    }

    return (0, _hyperhtml.default)(_templateObject27(), [conf.wgHTML], conf.anOrA, conf.longStatus, conf.notYetRec ? "This document is intended to become a W3C Recommendation." : "");
  }

  function linkToCommunity(conf, opts) {
    if (!conf.github && !conf.wgPublicList) {
      return;
    }

    return (0, _hyperhtml.default)(_templateObject28(), conf.github ? (0, _hyperhtml.default)(_templateObject29(), conf.issueBase) : "", conf.wgPublicList ? (0, _hyperhtml.default)(_templateObject30(), conf.github && conf.wgPublicList ? "Alternatively, you can send comments to our mailing list." : "Comments regarding this document are welcome.", opts.mailToWGPublicListWithSubject, conf.wgPublicList, "https://lists.w3.org/Archives/Public/".concat(conf.wgPublicList, "/"), conf.subjectPrefix ? (0, _hyperhtml.default)(_templateObject31(), conf.subjectPrefix) : "") : "");
  }
});
//# sourceMappingURL=sotd.js.map